import { ArrowRight } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { t } from "@/lib/i18n"

import { HeroBill } from "./hero-bill"
import type { LandingLinks } from "./types"

export function LandingHero({ links }: { links: LandingLinks }) {
  return (
    <section className="mx-auto grid w-full max-w-7xl gap-14 px-4 pb-20 pt-14 lg:grid-cols-[1.04fr_0.96fr] lg:items-center lg:pb-24 lg:pt-20">
      <div className="flex flex-col items-start">
        <Badge
          variant="outline"
          className="border-brand/30 bg-brand-subtle px-3 py-1 text-xs font-semibold uppercase tracking-[0.28em] text-brand-ink"
        >
          {t("ui.landing.hero.badge")}
        </Badge>

        <h1 className="rotulo mt-5 text-balance text-4xl sm:text-5xl lg:text-6xl">
          {t("ui.landing.hero.title")}
        </h1>

        <p className="mt-6 max-w-2xl text-pretty text-base leading-7 text-muted-foreground sm:text-lg sm:leading-8">
          {t("ui.landing.hero.description_before")}
          <strong className="font-semibold text-brand-ink">{t("ui.landing.hero.description_highlight")}</strong>
          {t("ui.landing.hero.description_after")}
        </p>

        <div className="mt-9 flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <Button asChild size="lg">
            <a href={links.staffRegistration}>
              {t("ui.landing.hero.primary_cta")}
              <ArrowRight />
            </a>
          </Button>
          <Button asChild size="lg" variant="outline">
            <a href="#product">{t("ui.landing.hero.secondary_cta")}</a>
          </Button>
        </div>

        <p className="mt-5 text-sm leading-6 text-muted-foreground">{t("ui.landing.hero.note")}</p>
      </div>

      <HeroBill />
    </section>
  )
}
